import AATLogo from '@/assets/branding/aboveallthings/above-all-things-logo.png';

export default {
  name: 'Above all Things',
  isSAML: true,
  allowPersonalCourses: false,
  logo: AATLogo,
  colors: {
    // Brand colors
    brand_primary: '#2B2A70',
    brand_primary_hover: '#212047',
    brand_primary_highlight: '#4B49C6',
    brand_primary_mid: '#343390',
    brand_primary_dark: '#080813',
    brand_secondary: '#1C1A33',
  },
};
